// extracted by mini-css-extract-plugin
export default {"confetti":"Winner_confetti__UlKXj","logo":"Winner_logo__eqgEw"};